@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.wrapper {
  font-size: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
}

.header {
  display: flex;
  align-items: center;

  > .success-icon {
    fill: @phone-verify--header--success--fill-color;
    height: 40px;
    width: 40px;
    padding: 12px;
  }

  > .failure-icon {
    fill: @phone-verify--header--failure--fill-color;
    height: 40px;
    width: 40px;
    padding: 15px;
  }
}

.failed {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ok-button {
  width: 50px;
}
